<template>
    <div>
        <div>
            <slot name="title"></slot>
        </div>
        <div class="flex flex-wrap md:flex-row flex-col-reverse">
            <div
                v-for="(value, key) in options"
                :key="key"
                class="w-full md:w-1/2 mt-1"
            >
                <custom-radio
                    v-model="option"
                    :val="key"
                    :warn="key.includes('nequi')"
                    :danger="key.includes('daviplata')"
                    :success="key.includes('cash')"
                    @input="onInput"
                >
                    <span>
                        {{ value }}
                    </span>
                </custom-radio>
            </div>
        </div>
    </div>
</template>

<script>
import {
    paymentMethodsCodes,
    paymentMethodsMerchant,
    paymentMethodsOutput
} from "@/common/fields/orders-payment-methods";

export default {
    name: "PaymentMethodsChecker",
    components: {},
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            default: () => "cash",
            type: String,
            required: false
        },
        mode: {
            default: () => "sales",
            type: String,
            required: false
        },
        allowedMethods: {
            default: () => [],
            type: Array,
            required: false
        }
        // enabled: {
        //     default: () => true,
        //     type: Boolean,
        //     required: false
        // }
    },
    emits: ["change"],
    data: () => ({
        options: paymentMethodsMerchant,
        option: ""
    }),
    computed: {},
    watch: {
        allowedMethods() {
            this.setOptions();
        }
    },
    async mounted() {
        this.setOptions();
        this.setInput(this.itemCurrent);
    },
    methods: {
        setOptions() {
            const methods = {
                sales: paymentMethodsMerchant,
                outputs: paymentMethodsOutput,
                orders: paymentMethodsCodes
            };
            const options = methods[this.mode] || paymentMethodsMerchant;
            if (!this.allowedMethods.length) {
                this.options = options;
                return;
            }
            const allowed = new Set(this.allowedMethods);
            this.options = Object.fromEntries(
                Object.entries(options).filter(([key]) => allowed.has(key))
            );
            const optionKeys = Object.keys(this.options);
            if (optionKeys.length && !allowed.has(this.option)) {
                this.option = optionKeys[0];
                this.onInput();
            }
        },
        onInput() {
            this.$emit("change", this.option);
        },
        setInput(value) {
            this.option = value;
        }
    }
};
</script>
